import React, { Component } from 'react'
import SettingTable from '../common/SettingTable';
import { Link } from 'react-router-dom'

class Users extends Component {
        constructor () {
                super()
                this.state = {
                        users: [],
                        me: []
                }
                this.handleDelete = this.handleDelete.bind(this);
                this.handleEdit = this.handleEdit.bind(this);
                this.fireRedirect = this.fireRedirect.bind(this);
        }

        componentDidMount () {
                axios.get('/api/users').then(response => {
                        this.setState({
                            users: response.data
                        });
                })
                axios.get('/api/me').then(response => {
                        this.setState({
                              me: response.data
                        })
                })
        }
        
        handleEdit(user) {
                this.props.history.push('/users/edit/' + user.id)
        }
        
        handleDelete (user) {
                if (window.confirm('ユーザー' + user.id +'を削除してもよろしいですか？')){
                        axios.post('api/users/delete/' + user.id).then(response => {
                                if(response.data.success){
                                       this.setState({
                                                users: this.state.users.filter(m => m.id != user.id)
                                        })
                                }
                        })
                }
        }
        
        fireRedirect(e) {
            e.preventDefault()
            this.props.history.push(e.currentTarget.getAttribute('href'));
        }
      
        render() {
                const columns = [
                        {name: 'id', title: 'ID', isSort: 0, type: 'text'},
                        {name: 'username', title: 'ユーザーID', isSort: 0, type: 'text', isSearch:true},
                        {name: 'name', title: '名前', isSort: 0, type: 'text'},
                        {name: 'role_users', title: '権限', isSort: 0, type: 'array'},
                        {name: 'created_at', title: '作成日', isSort: 0, type: 'date'},
                        {name: 'action', title: '操作', isSort: 0, type: 'action', elements: ['edit', 'delete'], view_except_ids: [], edit_except_ids: [], delete_except_ids: [this.state.me.id]}
                ]
                const base_url = window.location.origin
                return (
                    <React.Fragment>
                       <div className="row">
                            <div className="col-sm-12">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/home">ダッシュボード</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">社内ユーザー一覧</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <main id="main">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <h4 className="mt-2 mb-0 page-title">社内ユーザー一覧</h4>
                                                    <p className="mt-2 mb-0">社内ユーザーのログインURLは <strong>{ base_url }/login</strong> となります。</p>
                                                </div>
                                                <div className="col text-right">
                                                    <a onClick={this.fireRedirect} href="/users/create" className="btn btn-warning">社内ユーザー新規登録</a>
                                                </div>
                                            </div>
                                        </div>

                                        <SettingTable onDelete={this.handleDelete} onEdit={this.handleEdit} header={columns} data={this.state.users} columnSearch="title" />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </React.Fragment>
                )
        }
}

export default Users